import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore"
import { getAuth } from "@firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyB_FtSumgAMOMk-Q4_zFhhU42MkDjAa6GM",
    authDomain: "personal-site-8417b.firebaseapp.com",
    projectId: "personal-site-8417b",
    storageBucket: "personal-site-8417b.firebasestorage.app",
    messagingSenderId: "481854027955",
    appId: "1:481854027955:web:a87a852af49a8a16a258c6"
  };

const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const auth = getAuth(app);